import { type IWidgetOption } from '../../../../Widget.ts';
import { WidgetOptionDividerView } from './WidgetOptionDividerView.tsx';
import { WidgetOptionValueView } from './WidgetOptionValueView.tsx';

export interface IWidgetOptionViewProps {
  item: IWidgetOption;
  listeners?: any;
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function WidgetOptionView(props: IWidgetOptionViewProps) {
  if (!props.item) return null;
  switch (props.item.type) {
    case 'option':
      return <WidgetOptionValueView {...props} item={props.item} />;
    case 'divider':
      return <WidgetOptionDividerView {...props} item={props.item} />;
  }
}
